import Endpoints from "src/constants/endpoints";
import AxiosClient from "src/networking/axios-client/index.client";

import { Imprint } from "./index.models";
import { AxiosResponse } from "axios";

class ImprintsController {
  async getLatest(): Promise<Imprint> {
    const res = await AxiosClient.get({
      url: Endpoints.imprints,
      parser: (res) =>
        BaseControllerOverviewResposne.fromAxiosResponse<Imprint>(res),
    });

    return res.data;
  }

  async getByVersion(version: string): Promise<Imprint> {
    const res = await AxiosClient.get({
      url: Endpoints.imprints,
      queryParams: { version: version },
      parser: (res) =>
        BaseControllerOverviewResposne.fromAxiosResponse<Imprint>(res),
    });

    return res.data;
  }
}

class BaseControllerOverviewResposne<T> {
  constructor(public readonly data: T) {}

  static fromAxiosResponse<T>(
    res: AxiosResponse
  ): BaseControllerOverviewResposne<T> {
    return new BaseControllerOverviewResposne(res.data);
  }
}

export default ImprintsController;
